import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';

import { Box } from '../Box';
import { Column } from '../Layout';
import { GlImage } from '../Image';

export const ColumnContainer = styled(Column)`
  ${mediaQueries.desktop} {
    padding-top: ${pxToRem(70)};
    align-self: start;
  }
`;

export const ImageWrapper = styled(Box)`
  width: 100%;

  ${mediaQueries.tablet} {
    width: auto;
    flex: 1.5;
  }
`;

export const TextWrapper = styled(Box)`
  width: 100%;

  ${mediaQueries.tablet} {
    width: auto;
    flex: 1;
  }
`;

export const StyledImage = styled(GlImage)`
  max-width: 100%;
  display: block;
  margin: 0 auto;
  border-radius: ${({ theme }) => theme.borderRadius.block};
  z-index: 0;

  ${mediaQueries.desktop} {
    border-radius: ${({ theme }) => theme.borderRadius.block_desktop};
  }
`;
